module.exports = __webpack_public_path__ + "static/media/financial-services-square.5a1cb890.jpg";